<template>
  <el-dialog
    :title="title"
    width="600px"
    @close="handleHide"
    v-model="dialogVisible"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div style="padding-right: 20px">
      <el-alert
        :title="message"
        type="error"
        :closable="false"
        v-if="message"
        style="margin-top: -20px; margin-bottom: 20px"
      ></el-alert>
      <el-form :model="form" label-width="100px">
        <el-form-item label="用户名：" v-if="type == 'edit'">
          <el-input v-model="form.username" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="账号：" prop="email">
          <el-select
            v-show="batchFlag === false && type != 'edit'"
            v-model="form.usernameSelect"
            multiple
            filterable
            remote
            :remote-method="handleRemoteSearch"
            :loading="remoteLoading"
            style="width: 100%"
          >
            <el-option
              v-for="item in filteredKoaUserList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
          <el-input
            v-show="batchFlag === true || type == 'edit'"
            v-model="form.username"
            style="width: 100%"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 30 }"
            :disabled="type == 'edit'"
            :readonly="type == 'edit'"
            placeholder="请添加KOA账号不带后缀"
            :trigger-on-focus="false"
          ></el-input>
          <el-switch
            v-show="type != 'edit'"
            v-model="batchFlag"
            active-text="批量粘贴"
            inactive-text="录入添加"
          >
          </el-switch>
          <div v-if="batchFlag" class="help-text">
            可批量添加，一个账号一行。
          </div>
        </el-form-item>
        <el-form-item label="所属应用：">
          <el-select
            v-model="form.appids"
            multiple
            filterable
            @change="handleChangeSelect"
            placeholder="请选择所属应用 (支持关键字搜索)"
            style="width: 100%"
          >
            <AppSelectOptions :apps="projectApps" />
          </el-select>
          <el-checkbox v-model="checkAll" @change="handleChangeAll"
            >所有应用权限开放</el-checkbox
          >
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <div style="padding-right: 40px">
        <el-button @click="handleHide">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
          :disabled="form.username == '' && form.usernameSelect.length === 0"
          :loading="posting"
          >确 定</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { storeToRefs } from "pinia";
import {
  ref,
  defineProps,
  defineExpose,
  reactive,
  computed,
  getCurrentInstance,
  onMounted,
  defineEmits,
} from "vue";
import { useProjectStore } from "@/Store/ProjectStore";
import { apiAddTester, apiGetKoaUserList, apiModifyTester } from "@/Api/AppApi";
import AppSelectOptions from "@/Components/AppDetail/Detail/Info/AppSelectOptions.vue";

const props = defineProps({
  title: String,
  type: String, // invite/edit
});
defineExpose({ show });
const emit = defineEmits(["submit-success"]);

const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;

const projectStore = useProjectStore();
const { projectApps, currentProjectId } = storeToRefs(projectStore);

const batchFlag = ref(false);

const koaUserList = ref([]);
const filteredKoaUserList = ref([]);
const remoteLoading = ref(false);

let searchTimer = null;
function handleRemoteSearch(query) {
  if (searchTimer) clearTimeout(searchTimer);
  if (!query) {
    filteredKoaUserList.value = [];
    return;
  }
  remoteLoading.value = true;
  searchTimer = setTimeout(() => {
    const q = query.toLowerCase();
    filteredKoaUserList.value = koaUserList.value
      .filter((item) => item.toLowerCase().includes(q))
      .slice(0, 50);
    remoteLoading.value = false;
  }, 300);
}
async function getKoaUserList() {
  const res = await apiGetKoaUserList();
  if (res.code === 0) {
    koaUserList.value = res.data || [];
    console.log('koaUserList.value', koaUserOptions.value);
  } else {
    $message.error(res.message);
  }
}
onMounted(() => {
  getKoaUserList();
});

const dialogVisible = ref(false);
const message = ref("");
const form = reactive({
  username: "",
  email: "",
  appids: [],
  admin: [],
  usernameSelect: [],
});
const checkAll = ref(false);
function handleHide() {
  dialogVisible.value = false;
  message.value = "";

  form.username = "";
  form.email = "";
  form.appids = [];
  form.admin = [];
  form.usernameSelect = [];

  checkAll.value = false;
}
function show(data) {
  if (data) {
    for (const key in data) {
      form[key] = data[key];
    }
  }

  if (form.appids.length >= projectApps.value.length) {
    checkAll.value = true;
  } else {
    checkAll.value = false;
  }
  dialogVisible.value = true;
}

function handleChangeSelect() {
  checkAll.value = form.appids.length >= projectApps.value.length;
}
function handleChangeAll() {
  if (checkAll.value) {
    form.appids = projectApps.value.map((item) => item.id);
  } else {
    form.appids = [];
  }
}

const posting = ref(false);
async function handleSubmit() {
  let _username = "";
  if (batchFlag.value === false && props.type !== "edit") {
    _username = form.usernameSelect.join("\n");
  } else {
    _username = form.username;
  }
  const postData = {
    projectid: currentProjectId.value,
    username: _username,
    appids: form.appids,
  };
  const api = props.type == "invite" ? apiAddTester : apiModifyTester;
  posting.value = true;
  const res = await api(postData);
  posting.value = false;

  if (res.code === 0) {
    emit("submit-success");
    handleHide();
  } else if (res.code === 20005) {
    $message({
      showClose: true,
      message: res.message + "已存在，请重新输入账号！",
      type: "warning",
    });
  } else {
    message.value = res.message;
  }
}
</script>

<style scoped>
.help-text {
  font-size: 12px;
  color: #f56c6c;
  margin-left: 8px;
}
</style>
